export enum OrderStatus {
    declined = 'declined',
    pending = 'pending',
    started = 'started',
}
